.ux-w-wrapper {
    @include font(regular);
    box-shadow: 0 7px 22px transparentize($color-black, 0.9);
    display: block;

    &__body {
        display: flex;
        overflow-x: auto;
        min-height: 289px;
        position: relative;
    }

    &__loader {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }
}
